import React,{useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, eventURL, WorkshopListURL, WorkshopPublicURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import { Table, Toggle,Pagination } from "rsuite";
import { Fragment } from "react-read-more-read-less";

const { Column, HeaderCell, Cell } = Table;

const AttendeesWorkshopMultiple = () => {

    const [added, setAdded] = useState(false);
    const [publish, setPublish] = useState('');

    const [pageno, setPageno] = useState(0);

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText]=useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);



    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    const {wid, sid, id, workname} = useParams();

    let navigate = useNavigate();





    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopPublicURL+"workshopAttendees/view/"+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            if(response.data.message === "Success"){            
                console.log("current page ===>", response.data.data.currentPage);
                setResult(response.data.data.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
                setLoader(false)
                }else{
                setResult(false);
                setLoader(false);
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


   


    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Attendeess - {workname}</h2>
                        </div>


                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/workshop/session/"+wid+'/'+sid}>Workshop</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Attendees</li>

                        </ol>
				    </nav>



                    <div className="jobs-list-wrpr list-wrpr" >

                        {result?(
                        result?.map((item,index) =>
                            (
   
                                <>


                                <div className="list">
                                    <div className="row">
                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                        <span class="desig">Sl.No</span>
                                        {sl++}
                                        </div>
                                        </div>
                                        
                                        <div className="col-md-5">
                                            <div className="jobs-user" style={{lineBreak:'anywhere'}}>
                                            <span class="desig">Name</span>

                                            {decode(item.firstname +" "+ item.lastname )}
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="jobs-user">
                                            <span class="desig">Phone & Email</span>
                                                 {item.phone}<br />
                                                 {item.email}
                                            </div>
                                        </div>

                                    
                                        {/* <div className="col-md-3">
                                            <div className="list-action-wrpr text-right  roundicons-text event-btns">
                                                <button onClick={()=>{navigate("/workshop/session/view/"+wid+"/"+sid+"/"+item.id)}} style={{backgroundColor:'transparent'}}  data-toggle="tooltip" title="View" ><a><i className="delete icon-eye" style={{background:'#ff577f'}}></i><span>View</span></a></button>
                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </>
                           
                           
                           
                           )

                        )):null
                        }
                        {
                            result.length === 0?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
                        }

                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }





                </div>
            </aside>
        </div>
    )
}

export default AttendeesWorkshopMultiple;